import { CompetenceFields } from './interface';

export const competenceInitialValues: CompetenceFields = {
  competences: [],
};
